import { Add } from "@mui/icons-material";
import { Button, Stack, Typography } from "@mui/material";

type TeamHeaderProps = {
  onInvite: () => void;
};

const TeamHeader = ({ onInvite }: TeamHeaderProps) => {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      justifyContent='space-between'
      alignItems={{ xs: "flex-start", sm: "center" }}
      spacing={2}>
      <Typography color='text.secondary'>Управление доступом сотрудников к платформе</Typography>
      <Button
        variant='contained'
        startIcon={<Add />}
        onClick={onInvite}>
        Пригласить сотрудника
      </Button>
    </Stack>
  );
};

export default TeamHeader;
